<template>
  <div class="main-content">
    <!-- Formulário de Filtro -->
    <b-form
v-if="form"
@submit="onSubmit"
@reset="onReset"
>
      <div class="hist-periodo">
        <div class="hist-periodo__atalhos">
          <span>Período</span>
          <b-button
            v-for="shortcut in periodShortcuts"
            :key="shortcut.hours"
            size="sm"
            variant="outline-secondary"
            @click="setPeriod(shortcut.hours)"
          >
            {{ shortcut.label }}
          </b-button>
        </div>

        <div class="row">
          <b-form-group
            class="col-md-6"
            label="Início"
            label-for="form_dataFrist"
          >
            <div class="hist-periodo__campos">
              <b-form-datepicker
                id="form_dataFrist"
                v-model="form.dataFrist"
                :label-no-date-selected="$t('No date selected')"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
              />
              <b-form-input
                id="dataFrist_time"
                v-model="form.dataFristTime"
                type="time"
                step="60"
              />
            </div>
          </b-form-group>

          <b-form-group
            class="col-md-6"
            label="Fim"
            label-for="form_dataFim"
          >
            <div class="hist-periodo__campos">
              <b-form-datepicker
                id="form_dataFim"
                v-model="form.dataFim"
                :label-no-date-selected="$t('No date selected')"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
              />
              <b-form-input
                id="dataFim_time"
                v-model="form.dataFimTime"
                type="time"
                step="60"
              />
            </div>
          </b-form-group>
        </div>
      </div>

      <!-- Botões de Ação -->
      <div class="filtro-acoes">
        <b-button
          type="reset"
          variant="outline-secondary"
          size="sm"
        >
          {{ $t('Cancel') }}
        </b-button>

        <b-button
          type="submit"
          variant="primary"
          size="sm"
        >
          <i class="fa fa-search" /> {{ $t('Search') }}
        </b-button>
      </div>
    </b-form>

    <div
      v-if="carregando"
      class="hist-esqueleto"
    >
      <span>Carregando posições…</span>
    </div>

    <!-- Controle de Movimento e Zoom -->
    <div
v-else-if="routeCoordinates.length > 0"
class="form-group col-12"
>

      <!-- Barra de reprodução -->
      <div class="row align-items-center mt-3 mb-2 veh-controles">
        <div class="col-auto">
          <b-button
            :variant="isPlaying ? 'warning' : 'primary'"
            @click="actionPlay(!isPlaying)"
          >
            <i :class="isPlaying ? 'fa fa-pause' : 'fa fa-play'" />
            {{ isPlaying ? 'Pausar' : 'Reproduzir' }}
          </b-button>
        </div>

        <div class="col d-flex align-items-center">
          <input
            v-model.number="currentPointIndex"
            type="range"
            class="w-100"
            :min="0"
            :max="routeCoordinates.length - 1"
            step="1"
            @input="updateVehiclePosition"
          >
        </div>

        <div class="col-auto">
          <b-badge :variant="isPlaying ? 'primary' : 'secondary'">
            {{ currentPointIndex }} / {{ routeCoordinates.length - 1 }}
          </b-badge>
        </div>

        <div class="col-auto">
          <b-button
            variant="outline-secondary"
            :disabled="!routeCoordinates.length"
            :title="$t('Fit all positions on screen')"
            @click="fitAllPositions"
          >
            <feather-icon icon="MaximizeIcon" />
            {{ $t('Fit route') }}
          </b-button>
        </div>
      </div>

      <!-- Opções -->
      <div class="row align-items-start veh-controles">
        <b-form-group
          v-slot="{ ariaDescribedby }"
          class="col-md-4"
          label="Reprodução"
        >
          <b-form-radio-group
            id="radio-group-1"
            v-model="playInterval"
            :options="intervalOptions"
            :aria-describedby="ariaDescribedby"
            name="radio-options"
            class="mb-2"
          />
          <b-form-checkbox
            v-model="loopPlay"
            switch
          >
            Repetir continuamente
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          class="col-md-5"
          label="Visualização"
        >
          <b-form-checkbox
            v-model="followVehicle"
            switch
          >
            Acompanhar veículo
          </b-form-checkbox>
          <b-form-checkbox
            v-model="showPoints"
            switch
          >
            Mostrar posições
          </b-form-checkbox>
          <b-form-checkbox
            v-model="clusterPoints"
            switch
            :disabled="!showPoints"
          >
            Agrupar posições próximas
          </b-form-checkbox>
        </b-form-group>

        <div class="col-md-3 d-flex align-items-end justify-content-end">
          <b-button
            variant="outline-secondary"
            size="sm"
            @click="downloadCSV"
          >
            <i class="fa fa-download" /> Baixar CSV
          </b-button>
        </div>
      </div>

      <!-- Mapa -->
      <GmapMap
        ref="historyMap"
        :center="center"
        :zoom="getZoom"
        style="width: 100%; height: 1000px"
        @zoom_changed="handleZoomChanged"
      >
        <gmap-cluster
          v-if="showPoints"
          :key="clusterPoints ? 'agrupado' : 'solto'"
          :max-zoom="clusterPoints ? 16 : 0"
        >
          <GmapMarker
            v-for="(coord, index) in routeCoordinates"
            :key="index"
            :position="convertToLatLng(coord)"
            :icon="smallPointIcon"
            @click="selecionarPonto(coord, index)"
          />
        </gmap-cluster>

        <GmapInfoWindow
          v-if="pontoSelecionado"
          :position="convertToLatLng(pontoSelecionado)"
          :options="{ pixelOffset: { width: 0, height: -18 } }"
          @closeclick="pontoSelecionado = null"
        >
          <div class="ponto-info">
            <div class="ponto-info__titulo">
              Posição {{ pontoSelecionadoIndice + 1 }} de {{ routeCoordinates.length }}
            </div>
            <dl class="ponto-info__lista">
              <dt>Data e hora</dt>
              <dd>{{ formatarData(pontoSelecionado.position_date) }}</dd>
              <dt>Velocidade</dt>
              <dd>{{ formatarVelocidade(pontoSelecionado.speed) }}</dd>
              <dt>Coordenadas</dt>
              <dd class="ponto-info__mono">{{ pontoSelecionado.lat }}, {{ pontoSelecionado.lon }}</dd>
              <template v-if="pontoSelecionado.battery_info">
                <dt>Bateria</dt>
                <dd>{{ pontoSelecionado.battery_info }}</dd>
              </template>
              <template v-if="pontoSelecionado.device_name">
                <dt>Aparelho</dt>
                <dd>{{ pontoSelecionado.device_name }}</dd>
              </template>
              <template v-if="pontoSelecionado.version_app">
                <dt>Versão do app</dt>
                <dd>{{ pontoSelecionado.version_app }}</dd>
              </template>
            </dl>
          </div>
        </GmapInfoWindow>

        <!-- Marcador de Início e Fim -->
        <GmapMarker
v-if="startPoint"
:position="startPoint"
:icon="startIcon"
@click="toggleInfoWindow('start')"
/>
        <GmapInfoWindow
v-if="showInfoWindow === 'start'"
:position="startPoint"
>
          <div>Início</div>
        </GmapInfoWindow>

        <GmapMarker
v-if="endPoint"
:position="endPoint"
:icon="endIcon"
@click="toggleInfoWindow('end')"
/>
        <GmapInfoWindow
v-if="showInfoWindow === 'end'"
:position="endPoint"
>
          <div>Fim</div>
        </GmapInfoWindow>

        <!-- <GmapPolyline :path="routePath" :options="polylineOptions" /> -->
        <!-- <GmapMarker :position="vehiclePosition" :icon="vehicleIcon" v-if="vehiclePosition" @click="showVehicleDetails" /> -->
       <!-- Detalhes do veículo no marcador -->
        <GmapMarker
          v-if="vehiclePosition"
          :position="vehiclePosition"
          :icon="vehicleIcon"
          class="vehicle-marker"
          @click="toggleInfoWindow('vehicle')"
        />
          <GmapInfoWindow
v-if="showInfoWindow === 'vehicle'"
:position="vehiclePosition"
>
            <div>
              <tracking-point-info
                :point="currentPoint"
                :index="currentPointIndex"
                :total="routeCoordinates.length"
                :vehicle-datalhe="vehicleDatalhe"
              />
            </div>
          </GmapInfoWindow>
           <!-- Linha de rota -->
          <GmapPolyline
:path="routePath"
:options="polylineOptions"
/>
      </GmapMap>
    </div>
    <div
      v-else
      class="hist-vazio"
    >
      <feather-icon
        icon="MapIcon"
        size="34"
      />
      <p class="hist-vazio__titulo">Nenhuma posição para exibir</p>
      <p class="hist-vazio__ajuda">
        Escolha a data inicial e a data final acima e clique em <strong>Pesquisar</strong>
        para carregar o trajeto do veículo.
      </p>
    </div>
  </div>

</template>

<script>
import { RefreshCcwIcon } from 'vue-feather-icons'
import moment from 'moment'
import TrackingPointInfo from './TrackingPointInfo.vue'

export default {
  components: {
    TrackingPointInfo,
    RefreshCcwIcon,
  },
  props: {
    url: String,
    zoom: Number,
    routeCoordinates: { type: Array, default: () => [] },
    carregando: { type: Boolean, default: false },
    vehicleDatalhe: Object,
    animateAsVehicle: { type: Boolean, default: true },
  },
  data() {
    return {
      animationFrameId: null, // Armazena o ID da animação
      form: {
        limit: 10000,
        dataFrist: null,
        dataFim: null,
        dataFristTime: null,
        dataFimTime: null,
      },
      showInfoWindow: null,
      googlePronto: false,
      pontoSelecionado: null,
      pontoSelecionadoIndice: 0,
      notshow: ['_id', 'id_rec_position', 'cause', 'pid_captura'],
      showdata: ['timestampGateway', 'timestamp', 'MsgDateTime', 'CPRDateTime'],
      zoomData: 13,
      polylineOptions: {
        strokeColor: '#ff8800',
        strokeOpacity: 0.8,
        strokeWeight: 4,
      },
      startIcon: {
        url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
        label: {
          text: 'Início',
          color: '#008000',
          fontSize: '14px',
          fontWeight: 'bold',
        },
      },
      endIcon: {
        url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
        label: {
          text: 'Fim',
          color: '#FF0000',
          fontSize: '14px',
          fontWeight: 'bold',
        },
      },
      vehiclePosition: null,
      currentPointIndex: 0,
      animationInterval: null,
      smallPointIcon: null, // Inicializado posteriormente
      centerMap: { lat: 0, lng: 0 },
      centerFrist: null,
      selectedVehicleDetails: null,
      isPlaying: false,
      followVehicle: false,
      showPoints: true,
      clusterPoints: true,
      playInterval: 1000,
      loopPlay: false,
      showFilters: true,
      intervalOptions: [
        { value: 1000, text: '1x' },
        { value: 500, text: '2x' },
        { value: 250, text: '3x' },
        { value: 125, text: '4x' },
      ],
      periodShortcuts: [
        { label: '1 hora', hours: 1 },
        { label: '6 horas', hours: 6 },
        { label: '24 horas', hours: 24 },
        { label: '7 dias', hours: 168 },
      ],
    }
  },
  computed: {
    currentPoint() {
      if (!this.routeCoordinates || !this.routeCoordinates.length) {
        return null
      }

      const indice = Math.min(
        Math.max(this.currentPointIndex, 0),
        this.routeCoordinates.length - 1,
      )

      return this.routeCoordinates[indice]
    },
    getZoom() {
      return this.zoomData
    },
    center() {
      if (this.followVehicle && this.vehiclePosition && this.vehiclePosition.lat) {
        return this.vehiclePosition
      }
      if (this.routeCoordinates && this.routeCoordinates.length > 0) {
        const middleIndex = Math.floor(this.routeCoordinates.length / 2)
        return this.convertToLatLng(this.routeCoordinates[middleIndex])
      }
      return { lat: 0, lng: 0 }
    },
    startPoint() {
      return this.routeCoordinates[0] ? this.convertToLatLng(this.routeCoordinates[0]) : null
    },
    endPoint() {
      return this.routeCoordinates.length
        ? this.convertToLatLng(this.routeCoordinates[this.routeCoordinates.length - 1])
        : null
    },
    routePath() {
      return this.routeCoordinates.map(coord => this.convertToLatLng(coord))
    },
    vehicleHeading() {
      const pontos = this.routeCoordinates

      if (!pontos || pontos.length < 2) {
        return 0
      }

      const i = Math.min(this.currentPointIndex, pontos.length - 2)

      return this.computeHeading(
        this.convertToLatLng(pontos[i]),
        this.convertToLatLng(pontos[i + 1]),
      )
    },
    vehicleIcon() {
      const pronto = this.googlePronto

      if (pronto && window.google && this.isPlaying && this.animateAsVehicle) {
        return {
          url: this.ambulanceSvg(this.vehicleHeading),
          scaledSize: new window.google.maps.Size(60, 60),
          anchor: new window.google.maps.Point(30, 30),
        }
      }

      const detalhe = this.vehicleDatalhe || {}
      const url = this.url || detalhe.vehicle_image_url || null

      if (!url) {
        return null
      }

      if (!pronto || !window.google) {
        return url
      }

      return {
        url,
        scaledSize: new window.google.maps.Size(40, 60),
        anchor: new window.google.maps.Point(20, 60),
        origin: new window.google.maps.Point(0, 0),
      }
    },
  },
  watch: {
    routeCoordinates(novas, antigas) {
      if (!novas.length || novas === antigas) {
        return
      }

      if (this.followVehicle || this.isPlaying) {
        return
      }

      this.fitRouteWhenReady()
    },
  },
  mounted() {
    if (this.$gmapApiPromiseLazy) {
      this.$gmapApiPromiseLazy().then(() => {
        this.googlePronto = true
      })
    }

    this.setPeriod(1)

    if (this.routeCoordinates && this.routeCoordinates.length > 0) {
      this.updateVehiclePosition()
    }

    if (window.google) {
      this.smallPointIcon = {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: '#ff7300',
        fillOpacity: 1,
        scale: 3,
        strokeColor: '#ff7300',
        strokeWeight: 1,
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.animationInterval)
  },
  methods: {
    fitRouteWhenReady(attempt = 0) {
      if (!this.routeCoordinates.length) {
        return
      }

      if (this.$refs.historyMap && window.google) {
        this.fitAllPositions()
        return
      }

      if (attempt < 8) {
        this.$nextTick(() => {
          requestAnimationFrame(() => this.fitRouteWhenReady(attempt + 1))
        })
      }
    },
    setPeriod(hours) {
      const end = new Date()
      const start = new Date(end.getTime() - hours * 60 * 60 * 1000)
      const formatDate = value => value.toISOString().slice(0, 10)
      const formatTime = value => value.toTimeString().slice(0, 5)

      this.form.dataFrist = formatDate(start)
      this.form.dataFristTime = formatTime(start)
      this.form.dataFim = formatDate(end)
      this.form.dataFimTime = formatTime(end)
    },
    toggleFiltres() {
      this.showFilters = !this.showFilters
    },
    showVehicleDetails() {
      this.selectedVehicleDetails = this.routeCoordinates[this.currentPointIndex]
      this.showInfoWindow = 'vehicle'
    },
    toggleInfoWindow(marker) {
      this.showInfoWindow = this.showInfoWindow === marker ? null : marker
    },
    selecionarPonto(coord, indice) {
      this.pontoSelecionado = coord
      this.pontoSelecionadoIndice = indice
      this.currentPointIndex = indice
      this.updateVehiclePosition()
    },
    formatarData(valor) {
      if (!valor) {
        return '—'
      }

      const data = moment(valor)

      return data.isValid() ? data.format('DD/MM/YYYY HH:mm:ss') : valor
    },
    formatarVelocidade(valor) {
      const numero = Number(valor)

      return Number.isNaN(numero) ? '—' : `${numero.toFixed(2)} km/h`
    },
    setSelectedVehicleDetails(coord) {
      this.selectedVehicleDetails = coord
      this.showInfoWindow = 'vehicle'
    },
    //   toggleInfoWindow(marker) {
    // // Alterna entre mostrar e ocultar a janela de informação para o marcador clicado
    // this.showInfoWindow = this.showInfoWindow === marker ? null : marker;
    // },
    convertToLocalTime(gmtDate) {
      const gmtDateObject = new Date(`${gmtDate} GMT`)
      if (isNaN(gmtDateObject.getTime())) {
        throw new Error('Data inválida')
      }
      const day = String(gmtDateObject.getDate()).padStart(2, '0')
      const month = String(gmtDateObject.getMonth() + 1).padStart(2, '0')
      const year = gmtDateObject.getFullYear()
      const hours = String(gmtDateObject.getHours()).padStart(2, '0')
      const minutes = String(gmtDateObject.getMinutes()).padStart(2, '0')
      const seconds = String(gmtDateObject.getSeconds()).padStart(2, '0')
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
    },
    format_data(data) {
      return moment(`${data}`).format('DD/MM/YYYY HH:mm:ss')
    },
    downloadCSV() {
      // Filtra e formata os dados
      const formattedData = this.routeCoordinates.map(coord => {
        const newCoord = { ...coord }

        // Remove colunas indesejadas
        this.notshow.forEach(key => delete newCoord[key])

        // Formata as datas
        this.showdata.forEach(key => {
          if (newCoord[key]) {
            newCoord[key] = this.format_data(newCoord[key])
          }
        })
        return newCoord
      })

      // Converte para CSV
      const csvContent = [
        Object.keys(formattedData[0]).join(','), // Cabeçalhos
        ...formattedData.map(row => Object.values(row).join(',')), // Dados
      ].join('\n')

      // Cria um blob para download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)

      // Cria um link de download
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'route_coordinates.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    init() {
      this.zoomData = 16
      this.currentPointIndex = 0
    },
    onSubmit(event) {
      event.preventDefault()
      const searchFilter = {
        dataFrist: this.form.dataFrist ? `${this.form.dataFrist} ${this.form.dataFristTime || '00:00'}` : null,
        dataFim: this.form.dataFim ? `${this.form.dataFim} ${this.form.dataFimTime || '23:59'}` : null,
        limit: this.form.limit,
      }
      this.$emit('reload', searchFilter)
    },
    onReset(event) {
      event.preventDefault()
      this.form.dataFrist = null
      this.form.dataFristTime = null
      this.form.dataFim = null
      this.form.dataFimTime = null

      this.pausePlay()
      this.currentPointIndex = 0
      this.vehiclePosition = null
      this.pontoSelecionado = null
      this.showInfoWindow = null
      this.selectedVehicleDetails = null
      this.$emit('limpar')

      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    handleZoomChanged(newZoom) {
      this.zoomData = newZoom
    },
    actionPlay(is_playing) {
      if (is_playing) {
        this.startPlay()
        return
      }
      this.pausePlay()
    },
    lerp(start, end, t) {
      return {
        lat: start.lat + (end.lat - start.lat) * t,
        lng: start.lng + (end.lng - start.lng) * t,
      }
    },
    startPlay() {
      this.isPlaying = true
      this.showInfoWindow = 'vehicle'
      let startTime = null
      if (this.currentPointIndex >= this.routeCoordinates.length - 1) {
        this.currentPointIndex = 0
      }
      if (this.followVehicle) {
        this.zoomData = 20
      }
      const animate = timestamp => {
        if (!startTime) startTime = timestamp
        const progress = timestamp - startTime

        if (this.currentPointIndex < this.routeCoordinates.length - 1) {
          const startPoint = this.convertToLatLng(this.routeCoordinates[this.currentPointIndex])
          const endPoint = this.convertToLatLng(this.routeCoordinates[this.currentPointIndex + 1])

          const t = Math.min(progress / this.playInterval, 1)
          this.vehiclePosition = this.lerp(startPoint, endPoint, t)

          if (t >= 1) {
            this.currentPointIndex++
            startTime = null // Reinicia o tempo para o próximo segmento
          }

          // Agenda o próximo frame da animação
          this.animationFrameId = requestAnimationFrame(animate)
        } else if (this.loopPlay) {
          this.currentPointIndex = 0 // Reinicia para o começo se o loop estiver ativo
          startTime = null
          this.animationFrameId = requestAnimationFrame(animate)
        } else {
          this.pausePlay() // Pausar quando chegar ao final se o loop não estiver ativo
        }
      }

      // Inicia a animação
      this.animationFrameId = requestAnimationFrame(animate)
    },
    pausePlay() {
      this.isPlaying = false
      if (this.followVehicle) {
        this.zoomData = 16
      }
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId) // Cancela a animação
        this.animationFrameId = null // Limpa o ID da animação
      }
    },
    updateVehiclePosition() {
      this.vehiclePosition = this.convertToLatLng(this.routeCoordinates[this.currentPointIndex])
      console.log('this.vehiclePosition', this.vehiclePosition)
      this.showVehicleDetails()
    },
    ambulanceSvg(rumo) {
      const estrela = [
        '<g fill="#0B62B0">',
        '<rect x="28.4" y="25" width="3.2" height="13" rx="1.6"/>',
        '<rect x="28.4" y="25" width="3.2" height="13" rx="1.6" transform="rotate(60 30 31.5)"/>',
        '<rect x="28.4" y="25" width="3.2" height="13" rx="1.6" transform="rotate(120 30 31.5)"/>',
        '</g>',
      ].join('')

      const corpo = [
        '<rect x="18" y="6" width="24" height="48" rx="5" fill="#F2F4F6" stroke="#8C9198" stroke-width="1.2"/>',
        '<path d="M18 11 a5 5 0 0 1 5-5 h14 a5 5 0 0 1 5 5 v6 h-24 Z" fill="#E02322"/>',
        '<path d="M18 47 h24 v2 a5 5 0 0 1 -5 5 h-14 a5 5 0 0 1 -5 -5 Z" fill="#E02322"/>',
        '<path d="M21 17 h18 l-2 5 h-14 Z" fill="#8FC4E8"/>',
        '<rect x="22" y="49" width="16" height="4" rx="1" fill="#8FC4E8"/>',
        '<rect x="16.4" y="14" width="2.4" height="8" rx="1.2" fill="#3A3F45"/>',
        '<rect x="41.2" y="14" width="2.4" height="8" rx="1.2" fill="#3A3F45"/>',
        '<rect x="16.4" y="39" width="2.4" height="8" rx="1.2" fill="#3A3F45"/>',
        '<rect x="41.2" y="39" width="2.4" height="8" rx="1.2" fill="#3A3F45"/>',
        '<rect x="20" y="22.5" width="8" height="2.6" rx="1.3" fill="#1F6FD0"/>',
        '<rect x="32" y="22.5" width="8" height="2.6" rx="1.3" fill="#1F6FD0"/>',
        estrela,
        '<text x="30" y="45.5" font-family="Arial,Helvetica,sans-serif" font-size="6.5" font-weight="bold" fill="#E02322" text-anchor="middle">SAMU</text>',
        '<text x="30" y="12.5" font-family="Arial,Helvetica,sans-serif" font-size="5" font-weight="bold" fill="#FFFFFF" text-anchor="middle" transform="scale(-1,1) translate(-60,0)">SAMU 192</text>',
      ].join('')

      const svg = [
        '<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">',
        '<g transform="rotate(', Math.round(rumo), ' 30 30)">',
        corpo,
        '</g></svg>',
      ].join('')

      return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
    },
    computeHeading(de, para) {
      if (!de || !para || Number.isNaN(de.lat) || Number.isNaN(para.lat)) {
        return 0
      }

      const rad = Math.PI / 180
      const lat1 = de.lat * rad
      const lat2 = para.lat * rad
      const dLng = (para.lng - de.lng) * rad
      const y = Math.sin(dLng) * Math.cos(lat2)
      const sen = Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng)
      const x = Math.cos(lat1) * Math.sin(lat2) - sen

      return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360
    },
    fitAllPositions() {
      const mapa = this.$refs.historyMap

      if (!mapa || !window.google || !this.routeCoordinates.length) {
        return
      }

      mapa.$mapPromise.then(map => {
        const bounds = new window.google.maps.LatLngBounds()
        let total = 0

        this.routeCoordinates.forEach(coord => {
          const ponto = this.convertToLatLng(coord)

          if (Number.isFinite(ponto.lat) && Number.isFinite(ponto.lng)) {
            bounds.extend(ponto)
            total += 1
          }
        })

        if (!total) {
          return
        }

        if (total === 1) {
          map.setCenter(bounds.getCenter())
          map.setZoom(17)

          return
        }

        map.fitBounds(bounds, 32)
        window.google.maps.event.addListenerOnce(map, 'idle', () => {
          if (map.getZoom() > 17) {
            map.setZoom(17)
          }
        })
      })
    },
    convertToLatLng(coord) {
      return { lat: parseFloat(coord.lat), lng: parseFloat(coord.lon) }
    },
    showVehicleDetails() {
      this.selectedVehicleDetails = this.routeCoordinates[this.currentPointIndex]
    },
  },
  setup: {
    form: {
      limit: 10000,
      dataFrist: null,
      dataFim: null,
      dataFristTime: null,
      dataFimTime: null,
    },
  },
}
</script>

  <style>
  .hist-periodo {
    padding: 0.85rem 1rem 0.2rem;
    margin-bottom: 0.75rem;
    border: 1px solid rgba(34, 41, 47, 0.12);
    border-radius: 6px;
    background: #fafafc;
  }

  .hist-periodo__atalhos {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.45rem;
    margin-bottom: 0.85rem;
  }

  .hist-periodo__atalhos span {
    margin-right: 0.25rem;
    font-size: 0.78rem;
    font-weight: 600;
    color: #5e5873;
  }

  .hist-periodo__campos {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 8.5rem;
    gap: 0.5rem;
  }

  @media (max-width: 575.98px) {
    .hist-periodo {
      padding: 0.75rem;
    }

    .hist-periodo__campos {
      grid-template-columns: 1fr;
    }
  }

.filtro-acoes {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin: -0.5rem 0 1.25rem;
}

.veh-controles input[type='range'] {
  appearance: none;
  -webkit-appearance: none;
  height: 6px;
  border-radius: 999px;
  background: rgba(34, 41, 47, 0.12);
  outline: none;
}

.veh-controles input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #1f4e9c;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.veh-controles input[type='range']::-moz-range-thumb {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #1f4e9c;
  border: 2px solid #fff;
  cursor: pointer;
}

.veh-controles .badge {
  font-variant-numeric: tabular-nums;
}

.hist-esqueleto,
.hist-vazio {
  height: 32rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  text-align: center;
}

.hist-esqueleto {
  color: rgba(34, 41, 47, 0.45);
  font-size: 0.9rem;
  background: linear-gradient(
    90deg,
    rgba(34, 41, 47, 0.06) 25%,
    rgba(34, 41, 47, 0.11) 37%,
    rgba(34, 41, 47, 0.06) 63%
  );
  background-size: 400% 100%;
}

@media (prefers-reduced-motion: no-preference) {
  .hist-esqueleto {
    animation: hist-brilho 1.4s ease-in-out infinite;
  }
}

@keyframes hist-brilho {
  from { background-position: 100% 50%; }
  to { background-position: 0 50%; }
}

.hist-vazio {
  border: 1px dashed rgba(34, 41, 47, 0.15);
  color: rgba(34, 41, 47, 0.45);
  padding: 2rem;
}

.hist-vazio__titulo {
  margin: 0.4rem 0 0;
  font-weight: 600;
  font-size: 1rem;
  color: rgba(34, 41, 47, 0.6);
}

.hist-vazio__ajuda {
  margin: 0;
  max-width: 26rem;
  font-size: 0.88rem;
  line-height: 1.5;
}

.veh-controles {
  text-align: left;
}

.veh-controles .custom-checkbox {
  display: flex;
  align-items: center;
}

.veh-controles .custom-radio {
  display: inline-flex;
  align-items: center;
  margin-right: 1.15rem;
}

.veh-controles legend {
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  opacity: 0.45;
  padding-bottom: 0.55rem;
}

.veh-controles .custom-control-label {
  font-size: 0.88rem;
}

.veh-controles legend,
.veh-controles .col-form-label {
  text-align: left;
}

.ponto-info {
  min-width: 13rem;
  font-size: 0.82rem;
  line-height: 1.4;
}

.ponto-info__titulo {
  font-weight: 600;
  font-size: 0.9rem;
  padding-bottom: 0.4rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid rgba(34, 41, 47, 0.12);
}

.ponto-info__lista {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.25rem 0.9rem;
  margin: 0;
}

.ponto-info__lista dt {
  font-weight: 400;
  opacity: 0.6;
  white-space: nowrap;
}

.ponto-info__lista dd {
  margin: 0;
  font-weight: 600;
  text-align: right;
}

.ponto-info__mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.76rem;
}

  .vehicle-details-panel {
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  .vehicle-details-panel .row {
    display: flex;
    flex-wrap: wrap;
  }
  .vehicle-details-panel .col-md-3 {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }
  .vehicle-details-panel .fa-info-circle {
    margin-right: 5px;
    cursor: pointer;
  }
  .vehicle-marker {
    z-index: 1000; /* Garante que esteja acima */
  }
  </style>
